import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';
import {clientsAPI, userAPI} from '../API/api';
import {
	RegisterClientData,
	UserData,
	UserViewType,
} from '../types/TypesUser';

import {userApi} from './userApi';

const initialState: UserData = {
	auth: false,
	authData: {
		approve: false,
		cstcode: '',
		message: {codemsg: null, textmsg: ''},
		page: '',
		role_id: null,
		role_name: null,
		session_finish_date: '',
		status: '',
		user_id: null,
	},
	userStatTree: null,
	userView: null,
	userRefLink: null,
	studyStatus: null,
	userInfo: null,
};

export const registerUser = createAsyncThunk(
	'user/register',
	async (
		{
			registerData,
			resetForm,
			setStatus,
		}: {
			registerData: RegisterClientData;
			resetForm: () => void;
			setStatus: any;
		},
		{rejectWithValue},
	) => {
		try {
			const response = await clientsAPI.regRequest(registerData);
			if (response.data.approve) {
				resetForm();
				console.log(response.data.message.textmsg);
				return response.data;
			}
			return rejectWithValue(response.data);
		} catch (error: any) {
			const errors = error.response.data.errors;
			setStatus(errors);
			console.log(error);
			return rejectWithValue(errors);
		}
	},
);

export const logout = createAsyncThunk(
	'user/logout',
	async (_, {rejectWithValue}) => {
		try {
			await userAPI.laraLogout();
			if (typeof window !== 'undefined') {
				const redirectUrl =
					process.env.REACT_APP_DOMEIN_URL && process.env.REACT_APP_DOMEIN_URL.trim().length > 0
						? process.env.REACT_APP_DOMEIN_URL
						: '/';
				window.location.href = redirectUrl;
			}
			return true;
		} catch (error: any) {
			if (error?.response?.data) {
				return rejectWithValue(error.response.data);
			}
			return rejectWithValue(error?.message || 'Logout failed');
		}
	},
);


// Создаем slice
const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		// Синхронные actions
		setUserView: (state, action: PayloadAction<UserViewType | null>) => {
			state.userView = action.payload;
		},
		logoutUser: (state) => {
			// Очищаем состояние пользователя при выходе
			state.auth = false;
			state.authData = {
				approve: false,
				cstcode: '',
				message: {codemsg: null, textmsg: ''},
				page: '',
				role_id: null,
				role_name: null,
				session_finish_date: '',
				status: '',
				user_id: null,
			};
			state.userView = null;
			state.userRefLink = null;
			state.studyStatus = null;
			state.userInfo = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(logout.fulfilled, (state) => {
			userSlice.caseReducers.logoutUser(state);
		});
		builder.addCase(logout.rejected, (state) => {
			userSlice.caseReducers.logoutUser(state);
		});
		// Интеграция с RTK Query для автоматического обновления состояния
		builder.addMatcher(
			userApi.endpoints.getUserInfo.matchFulfilled,
			(state, action) => {
				if (action.payload.approve) {
					state.userInfo = action.payload;
				}
			},
		);
	},
});

// Экспортируем actions и reducer
export const {setUserView, logoutUser} = userSlice.actions;

export default userSlice.reducer;
